import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TaskNotification } from '../../api/tasks';

interface State {
  items: TaskNotification[];
  hydrated: boolean;
}

const initialState: State = { items: [], hydrated: false };

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    bulkHydrate(state, action: PayloadAction<TaskNotification[]>) {
      state.items = action.payload;
      state.hydrated = true;
    },
    pushNotification(state, action: PayloadAction<TaskNotification>) {
      // Dedupe by id (backend may resend on reconnect)
      if (state.items.some(i => i.id === action.payload.id)) return;
      state.items.unshift(action.payload);
      // Cap at 100 in memory; bell shows 50 anyway
      if (state.items.length > 100) state.items.length = 100;
    },
    markRead(state, action: PayloadAction<string>) {
      const it = state.items.find(i => i.id === action.payload);
      if (it) it.is_read = true;
    },
    markAllRead(state) {
      state.items.forEach(i => { i.is_read = true; });
    },
    clearNotifications(state) {
      state.items = [];
      state.hydrated = false;
    },
    removeNotification(state, action: PayloadAction<string>) {
      state.items = state.items.filter(i => i.id !== action.payload);
    },
    removeAllNotifications(state) {
      state.items = [];
    },
  },
});

export const {
  bulkHydrate, pushNotification, markRead, markAllRead, clearNotifications,
  removeNotification, removeAllNotifications,
} = slice.actions;

interface RootWithNotifications { notifications: State }
export const selectNotifications = (s: RootWithNotifications) => s.notifications.items;
export const selectUnreadCount = (s: RootWithNotifications) =>
  s.notifications.items.filter(i => !i.is_read).length;
export const selectNotificationsHydrated = (s: RootWithNotifications) => s.notifications.hydrated;

export default slice.reducer;
